import {override} from 'mobx';
import {Screen} from '../../Common/stores/Screen';
import {PersonalMenuCollection} from './PersonalMenuCollection';

export class PersonalMenuScreen extends Screen {
    newTitle;
    constructor(screen, name) {
        super(screen, name);

        this.newTitle = screen.newTitle;
        this.collection = new PersonalMenuCollection(null);
    }

    setCollection(data) {
        this.collection.insertFields(this, data.fields);
    }

    @override get loading() {
        return this.isLoading;
    }

    checkReloadNeeded(screensStore) {
        return false;
    }

    @override resetSelected() {
        this.setActive(null);
        this.setSelected(null);
        this.collection.setExpanded(false);
    }
}
